export default __webpack_public_path__ + "images/8R.93b058e.png";